module.exports = __webpack_public_path__ + "img/logo-footer.c3b22e40.svg";